import styled from 'styled-components';

export const SvgStyled = styled.svg`
    > path {
        fill: ${({ fill, customColor, theme }) => {
            if (customColor) return customColor;
            if (fill && fill !== "none") return fill;
        }};
        /* stroke: ${({ stroke, customColor, theme }) => {
            if (customColor) return customColor;
            return stroke ? stroke : '#222222';
        }}; */
    }
`;